module.exports = __webpack_public_path__ + "img/competition-egenting-2-2018.73530e29.png";